@if (showButton) {
  <button
    (click)="scrollToTop()"
    class="fixed bottom-8 right-8 z-40 w-14 h-14 bg-white hover:bg-gray-50 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group border-2 border-gray-200"
    aria-label="Scroll to top"
  >
    <svg
      class="w-7 h-7 transform group-hover:-translate-y-1 transition-transform duration-300"
      fill="none"
      stroke="#e8343f"
      viewBox="0 0 24 24"
      stroke-width="2.5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M5 10l7-7m0 0l7 7m-7-7v18"
      ></path>
    </svg>
  </button>
}
